import { usePrinterApi } from "../api/PrinterApiClient";
import { PrinterFrontendService } from "../services/PrinterFrontendService";

export const usePrinterService = (): PrinterFrontendService =>
  new PrinterFrontendService(usePrinterApi());
